import { createSlice } from '@reduxjs/toolkit'
import api from 'api/axios/foka'
import { createAxiosThunk } from 'utils/reduxUtil'

const initialState = {
  restrictionIps: [],
  page: 0,
  size: 10,
  selectedIds: [],
  totalElements: 0,
  loading: true,
  error: null,
}

export const fetchRestrictionIps = createAxiosThunk(
  'restrictionIpList/fetchRestrictionIps',
  (no, { getState }) => {
    const {
      restrictionIpList: { page, size },
    } = getState().restrictionIp
    return api.restrictionIp.getRestrictionIps({ page, size })
  }
)

export const deleteRestrictionIps = createAxiosThunk(
  'restrictionIpList/deleteRestrictionIp',
  ids => api.restrictionIp.deleteRestrictionIps({ ids })
)

const restrictionIpListSlice = createSlice({
  name: 'restrictionIpList',
  initialState,

  reducers: {
    reset: () => initialState,
    setPage: (state, { payload: page }) => {
      state.page = page
    },
    setSize: (state, { payload: size }) => {
      state.size = size
    },
    setSelectedIds: (state, { payload }) => {
      state.selectedIds = payload
    },
  },

  extraReducers: builder => {
    builder.addCase(fetchRestrictionIps.pending, state => {
      state.loading = true
    })

    builder.addCase(fetchRestrictionIps.fulfilled, (state, { payload }) => {
      const { content, totalElements } = payload.restrictionIps
      state.restrictionIps = content.map(
        ({ id, ip, description, createdDate }) => ({
          id,
          ip,
          description,
          enrollDate: createdDate,
        })
      )
      state.totalElements = totalElements
      state.loading = false
    })

    builder.addCase(fetchRestrictionIps.rejected, (state, action) => {
      state.error = action.payload || true
    })

    builder.addCase(deleteRestrictionIps.pending, state => {
      state.loading = true
    })

    builder.addCase(deleteRestrictionIps.fulfilled, state => {
      state.loading = false
    })

    builder.addCase(deleteRestrictionIps.rejected, state => {
      state.loading = false
    })
  },
})

export const { setPage, reset, setSelectedIds, setSize } =
  restrictionIpListSlice.actions

export default restrictionIpListSlice.reducer
